import React, { useState } from "react";
import { ReactComponent as KebabMenuIcon } from "../../../../Assets/ActionIcons/KebabMenuIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../Assets/ActionIcons/DeleteIcon.svg";
import { ReactComponent as EmailIcon } from "../../../../Assets/SettingsPages/EmailIcon.svg";
import Dropdown from "../../../../Components/Atoms/Dropdown";
import Modal from "../../../../Components/Atoms/Modal";
import { User } from "../../../../Contracts/User";

export interface UserManagementActionMenuProps {
  user: User;
  onEdit?: (userId: number, firstName: string, lastName: string) => void;
  onDelete: (user: User) => void;
  onResendInvite?: (userId: string) => void;
}

const UserManagementActionMenu: React.FC<UserManagementActionMenuProps> = ({
  user,
  onEdit,
  onResendInvite,
  onDelete
}) => {
  const [inputFirstName, setInputFirstName] = useState<string>(user.first_name);
  const [inputLastName, setInputLastName] = useState<string>(user.last_name);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [isResendInviteModalOpen, setIsResendInviteModalOpen] = useState<boolean>(false);
  return (
    <>
      <Dropdown
        position="bottom-right"
        onChange={value => {
          if (value === "edit") {
            setIsEditModalOpen(true);
          } else if (value === "delete") {
            setIsDeleteModalOpen(true);
          } else if (value === "resend_invite") {
            setIsResendInviteModalOpen(true);
          }
        }}
        options={[
          {
            label: (
              <div className="flex items-center space-x-2 text-red-600 px-4 py-2">
                <DeleteIcon />
                <div>Delete</div>
              </div>
            ),
            value: "delete",
            disabled: user.is_admin || user.is_owner,
            disabledMessage: user.is_admin
              ? "You cannot delete an admin user"
              : "You cannot delete an owner user"
          },
          ...(user.user_type === "team_invite"
            ? [
                {
                  label: (
                    <div className="flex items-center space-x-2 px-4 py-2 hover:bg-gray-200">
                      <EmailIcon />
                      <div>Resend Invite</div>
                    </div>
                  ),
                  value: "resend_invite"
                }
              ]
            : [])
        ]}
        anchor={
          <div className="cursor-pointer flex flex-col items-center">
            <KebabMenuIcon className="text-blue-600" />
            <div className="text-blue-600">More</div>
          </div>
        }
      />
      <Modal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        title="Delete User"
        okText="Delete"
        onOk={() => {
          onDelete(user);
          setIsDeleteModalOpen(false);
        }}
      >
        <p className="mb-2">
          Are you sure you want to delete {user.first_name} {user.last_name}?
        </p>
      </Modal>

      {/*This was implemented however the action button was commented out since this doesn't exist in v1*/}
      <Modal
        isOpen={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
          setInputFirstName(user.first_name);
          setInputLastName(user.last_name);
        }}
        title="Edit user"
        okText="Save"
        onOk={() => {
          if (onEdit) {
            onEdit(user.id, inputFirstName, inputLastName);
          }
          setIsEditModalOpen(false);
        }}
      >
        <div className="grid grid-cols-3 items-center justify-items-start">
          <label className="col-span-1">First Name</label>
          <input
            type="text"
            placeholder="First Name"
            className="border border-gray-200 rounded p-2 my-2 col-span-2"
            value={inputFirstName}
            onChange={e => setInputFirstName(e.target.value)}
          />
          <label className="col-span-1">Last Name</label>
          <input
            type="text"
            placeholder="Last Name"
            className="border border-gray-200 rounded p-2 my-2 col-span-2"
            value={inputLastName}
            onChange={e => setInputLastName(e.target.value)}
          />
          <label className="col-span-1">Email</label>
          <input
            type="text"
            placeholder="Email"
            className="border border-gray-200 rounded p-2 my-2 col-span-2"
            value={user.email}
            disabled
          />
        </div>
      </Modal>
      <Modal
        isOpen={isResendInviteModalOpen}
        onClose={() => setIsResendInviteModalOpen(false)}
        title="Resend Invite"
        okText="Resend"
        onOk={() => {
          if (onResendInvite) {
            onResendInvite(user.id.toString());
          }
          setIsResendInviteModalOpen(false);
        }}
      >
        <p className="mb-2">Are you sure you want to resend the invite to {user.email}?</p>
      </Modal>
    </>
  );
};

export default UserManagementActionMenu;
